import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { HideIcon, ShowIcon } from "@icons";

interface VisibilityButtonProps {
    /** The column's name, so each eye has its own accessible name. */
    name: string;
    isVisible: boolean;
    /** A column that can't be hidden: the eye is off and says why. */
    isLocked?: boolean;
    onToggleVisibility: () => void;
}

/** A column row's eye: hides a shown column or shows a hidden one. */
export const VisibilityButton = ({
    name,
    isVisible,
    isLocked = false,
    onToggleVisibility,
}: VisibilityButtonProps) => {
    const button = (
        <Button
            variant="secondary"
            size="sm"
            iconOnly
            aria-label={`${isVisible ? "Hide" : "Show"} ${name} column`}
            disabled={isLocked}
            onClick={onToggleVisibility}
        >
            {isVisible ? <HideIcon /> : <ShowIcon />}
        </Button>
    );

    return isLocked ? (
        <Tooltip content="Can't hide this column">{button}</Tooltip>
    ) : (
        button
    );
};
